import { Box, Typography } from "@mui/material";
import { useUnit } from "effector-react";
import { useEffect, useState } from "react";

import { fetchGetPlayerData } from "../store";
import { $gameConfig } from "../store";
import type { TokenValleyBlockType } from "../types/tokenValley";
import { formatTimeDMS } from "../utils/formatTimeDMS";

const BlockTimer = ({ block }: { block: TokenValleyBlockType }) => {
  const [gameConfig] = useUnit([$gameConfig]);
  const [timeRemaining, setTimeRemaining] = useState<number>(
    block.block_time_ready - Date.now(),
  );

  const buildSpec = gameConfig?.buildings_spec?.[block.block_type];
  const buildTime = buildSpec?.production_levels[1].build_cost?.time ?? 0;
  const startedAt = block.block_time_ready - buildTime;

  useEffect(() => {
    const updateRemaining = () => {
      const now = Date.now();
      const remaining = Math.max(0, block.block_time_ready - now);
      setTimeRemaining(remaining);

      if (remaining <= 0) {
        fetchGetPlayerData();
      }
    };

    updateRemaining();

    const interval = setInterval(updateRemaining, 1000);
    return () => clearInterval(interval);
  }, [block.block_time_ready]);

  const totalDuration = block.block_time_ready - startedAt;
  const progress = totalDuration > 0 ? 1 - timeRemaining / totalDuration : 1;

  if (timeRemaining <= 0) return null;

  return (
    <Box
      position="absolute"
      width="60%"
      zIndex={1}
      bottom={0}
      left={17}
      gap={0}
      display="flex"
      justifyContent="center"
    >
      <Typography
        color="white"
        fontSize="8px"
        zIndex={2}
        position="absolute"
        bottom="-8px"
      >
        {formatTimeDMS(timeRemaining)}
      </Typography>

      <Box
        mt="18px"
        width="100%"
        height="7px"
        borderRadius="10px"
        bgcolor="rgba(10, 56, 38, 1)"
        overflow="hidden"
      >
        <Box
          width={`${progress * 100}%`}
          height="100%"
          sx={{
            transition: "width 1s linear",
            background:
              "linear-gradient(90deg, rgba(88,248,160,1) 0%, rgba(30,192,103,1) 100%)",
          }}
        />
      </Box>
    </Box>
  );
};

export default BlockTimer;
